import { style } from '@primeuix/styles/imagecompare';
import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-imagecompare',
  slider: 'p-imagecompare-slider'
};
var ImageCompareStyle = BaseStyle.extend({
  name: 'imagecompare',
  style: style,
  classes: classes
});

export { ImageCompareStyle as default };
//# sourceMappingURL=index.mjs.map
